import { useInfiniteHits } from "react-instantsearch";
import { createInfiniteHitsSessionStorageCache } from "react-instantsearch-dom";

const sessionStorageCache = createInfiniteHitsSessionStorageCache();

export const useCachedInfiniteHits = () => {
  return useInfiniteHits({ cache: sessionStorageCache });
};
